import styled from 'styled-components';

export const AppContainerUI = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  min-height: 100vh;
`;
